import type { QuickAction } from "../types";

export const QUICK_ACTIONS: QuickAction[] = [
  {
    id: "posture",
    label: "Compliance posture",
    description: "Overall score across frameworks",
    prompt: "What is our current compliance posture?",
    icon: "gauge",
  },
  {
    id: "vulnerabilities",
    label: "Open vulnerabilities",
    description: "Findings grouped by severity",
    prompt: "Show me open vulnerabilities by severity",
    icon: "bug",
  },
  {
    id: "assets",
    label: "Asset inventory",
    description: "Coverage across the estate",
    prompt: "Give me an overview of our asset inventory",
    icon: "server",
  },
  {
    id: "audit",
    label: "Audit readiness",
    description: "Evidence and gaps before the audit",
    prompt: "Are we ready for the upcoming audit?",
    icon: "clipboard",
  },
  {
    id: "risk",
    label: "Risk summary",
    description: "Top risks weighted by impact",
    prompt: "Summarize our top risks",
    icon: "alert",
  },
  {
    id: "noncompliant",
    label: "Non-compliant controls",
    description: "Controls that are failing today",
    prompt: "Which controls are non-compliant?",
    icon: "shield",
  },
];

export const SUGGESTED_PROMPTS: string[] = [
  "Generate insights for this week",
  "Frameworks at a glance",
  "What changed since last month?",
];
